import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when the kicking team fields a ball off the rebound net on a kickoff (Indoor Football).
 * The kicking team retains possession at the spot.
 */
export default class ReboundNetFieldedKicking extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.ReboundNetFieldedKicking
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { fieldedBy, fieldedAt } = fragment;

        // Kicking team retains possession (they already had it)
        if (fieldedBy) {
            gameContext.setCurrentPlayerInPossession(fieldedBy);
        }
        if (fieldedAt || fieldedAt === 0) {
            gameContext.setFieldPosition(fieldedAt);
        }
        ruleContext.setAwardFirstDown(true);
    }
}
